module.exports = {
	HEADINGS: {
		COMMON: 'Core',
		UNCOMMON: 'Advanced',
		RARE: 'Expert',
		EPIC: 'Epic'
	},
	ROW_HEADER: 'Summary'
};
